// @flow

export const SERVICE_ENUM = {
  THINGSBOARD: 'THINGSBOARD',
  CHARGEBEE: 'CHARGEBEE',
  ODOO: 'ODOO'
};
